var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58 8.313H4.265V19H7.58V8.313zM12.974 13.713c0-1.394.264-2.744 1.99-2.744 1.7 0 1.723 1.594 1.723 2.834V19H20v-5.862c0-2.878-.62-5.091-3.977-5.091-1.614 0-2.695.886-3.138 1.726h-.044v-1.46h-3.18V19h3.313v-5.287zM5.923 6.852a1.925 1.925 0 000-3.852A1.924 1.924 0 004 4.925c0 1.063.86 1.927 1.923 1.927z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNTgwNDkgOC4zMTI2Mkg0LjI2NDY1VjE5SDcuNTgwNDlWOC4zMTI2MloiIGZpbGw9ImN1cnJlbnRjb2xvciIvPgo8cGF0aCBkPSJNMTIuOTczOCAxMy43MTI5QzEyLjk3MzggMTIuMzE4OSAxMy4yMzgxIDEwLjk2ODYgMTQuOTYzNyAxMC45Njg2QzE2LjY2NCAxMC45Njg2IDE2LjY4NjkgMTIuNTYyNyAxNi42ODY5IDEzLjgwMjdWMTlIMjAuMDAwM1YxMy4xMzc3QzIwLjAwMDMgMTAuMjYwMSAxOS4zODAzIDguMDQ2NzEgMTYuMDIyNiA4LjA0NjcxQzE0LjQwOTQgOC4wNDY3MSAxMy4zMjc3IDguOTMyNjMgMTIuODg1MyA5Ljc3Mjc5SDEyLjg0MTFWOC4zMTI2M0g5LjY2MDE2VjE5SDEyLjk3MzhWMTMuNzEyOVoiIGZpbGw9ImN1cnJlbnRjb2xvciIvPgo8cGF0aCBkPSJNNS45MjI4OCA2Ljg1MTY4QzYuOTgzMiA2Ljg1MTY4IDcuODQ0NjQgNS45ODgzMiA3Ljg0NDY0IDQuOTI1MjhDNy44NDQ0OCAzLjg2MzA0IDYuOTgzMiAzIDUuOTIyODggM0M0Ljg2MDMyIDMgNCAzLjg2MzA0IDQgNC45MjUyOEM0IDUuOTg4NDggNC44NjAzMiA2Ljg1MTY4IDUuOTIyODggNi44NTE2OFoiIGZpbGw9ImN1cnJlbnRjb2xvciIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };